export const PrintPreferences = {
  ELN_PAPER_SIZE: 'eln.print-paperSize',
  ELN_FIT_TO_WIDTH: 'eln.print-fitToWidth',
  ELN_ORIENTATION: 'eln.print-orientation',
  ELN_SHOW_LINK_URLS: 'eln.print-showLinkURLs',
  LABEL_PRINTING_OPTIONS_NAMESPACE: 'labelPrintingOptions',
  BARTENDER_LABEL_PRINTING_OPTIONS_NAMESPACE: 'labelPrintingOptions.bartender',
  // Keep in sync with benchling/lib/preferences.py::LABEL_PRINTING_TIMEZONE_KEY
  LABEL_PRINTING_TIMEZONE: 'labelPrintingTimezone',
};

export enum PrintOrientation {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT',
}

export enum PaperSize {
  US_LETTER = 'US_LETTER',
  A4 = 'A4',
}

export const ALL_PAPER_SIZES = [PaperSize.US_LETTER, PaperSize.A4];

const CM_PER_INCH = 2.54;

export const PAPER_SIZE_INFO = {
  [PaperSize.US_LETTER]: {
    name: 'Letter (8.5\u201D x 11\u201D)',
    cssName: 'letter',
    width: 8.5,
    height: 11,
  },
  [PaperSize.A4]: {
    name: 'A4 (210mm x 297mm)',
    cssName: 'A4',
    width: 21.0 / CM_PER_INCH,
    height: 29.7 / CM_PER_INCH,
  },
};

export const PRINT_PAGE_INFO = {
  // Empirically verified that Chrome and Firefox use 96ppi when printing
  ppi: 96,
  margins: {
    top: 1 / CM_PER_INCH,
    right: 1 / CM_PER_INCH,
    bottom: 1 / CM_PER_INCH,
    left: 1 / CM_PER_INCH,
  },
};

export const SAFARI_PAGE_INFO = {
  // Empirically verified that Safari uses 90ppi when printing
  ppi: 90,
  // Safari does not support @margin, so we use the default margins
  margins: {
    top: 0.25,
    right: 0.25,
    bottom: 1, // Safari seems to have 0.75in below the footer, with an additional 0.25in above.
    left: 0.25,
  },
};
